module.exports = __webpack_public_path__ + "img/result.cf1f268c.png";